module.exports = __webpack_public_path__ + "fonts/colimageuser.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/colimageuser.svg
// module id = 2214
// module chunks = 0